import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Week } from "../../../components/week-picker";
import { AppDispatch } from "../../../redux/store";
import WeeklySummaryForm from "./weekly-summary-form";
import {
  CommentWeeklySummaryRequest,
  commentWeeklySummaryStateAction,
  getCommentWeeklySummaryState,
  getWeeklySummaryState,
  userWeeklySummaryStateAction,
  WeeklySummaryComment,
} from "../../../redux/features/weekly-summary-slice";
import { dateFormatter } from "../../../core/utils";
import EmptyDataOverlay from "../../../components/empty-data-overlay";
import { getUserState } from "../../../redux/features/auth-slice";
import SummaryCommentsList from "../../weekly-report/components/summary-comments-list";
import { UserResponse } from "../../../redux/features/user-slice";
import { summaryOptions } from "../../../core/utils/constants";

interface Props {
  member: UserResponse;
  weekRange: Week;
}

export default function WeeklySummaryTab(props: Props) {
  const { member, weekRange } = props;

  const dispatch = useDispatch<AppDispatch>();
  const user = useSelector(getUserState).data;
  const weeklySummary = useSelector(getWeeklySummaryState).data;
  const commentWeeklySummary = useSelector(getCommentWeeklySummaryState).data;

  const [selectedOption, setSelectedOption] = useState<string>(
    summaryOptions[0]
  );

  const fetchWeeklySummary = useCallback(async () => {
    await dispatch(
      userWeeklySummaryStateAction({
        userId: member.id,
        start: dateFormatter(weekRange.firstDay, "yyyy-MM-dd"),
        end: dateFormatter(weekRange.lastDay, "yyyy-MM-dd"),
      })
    );
  }, [dispatch, member, weekRange]);

  const submitCommentWeeklySummary = async (
    values: CommentWeeklySummaryRequest
  ) => {
    await dispatch(commentWeeklySummaryStateAction(values));
  };

  useEffect(() => {
    fetchWeeklySummary();
  }, [fetchWeeklySummary]);

  useEffect(() => {
    if (commentWeeklySummary && commentWeeklySummary.success) {
      fetchWeeklySummary();
    }
  }, [commentWeeklySummary]);

  return weeklySummary && user ? (
    <div
      className="grid grid-cols-6 gap-4"
      style={{
        height: "calc(100% - 58px)",
      }}
    >
      <div className="col-span-4 flex flex-col overflow-y-hidden">
        <WeeklySummaryForm
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          summary={weeklySummary}
          onRefresh={fetchWeeklySummary}
        />
      </div>
      <div className="h-full col-span-2 overflow-y-hidden">
        <SummaryCommentsList
          user={user}
          comments={weeklySummary.comments}
          setComments={(values: WeeklySummaryComment[]) =>
            submitCommentWeeklySummary({
              id: weeklySummary.id,
              comments: values,
            })
          }
        />
      </div>
    </div>
  ) : (
    <EmptyDataOverlay label="No Summary found" exClassName="h-96" />
  );
}
